function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#27A17B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0056 10.2283C16.0056 9.47453 13.9545 8.84563 11.2289 8.70053L11.2287 7.49951H14.6319V5H5.326V7.49951H8.72899V8.70641C6.05301 8.86145 4.05127 9.48379 4.05127 10.2283C4.05127 10.9729 6.05301 11.5953 8.72899 11.7501V16.0629H11.2287V11.756C13.9545 11.6112 16.0056 10.9821 16.0056 10.2283ZM10.0284 10.9709C7.1028 10.9709 4.73107 10.5181 4.73107 9.95918C4.73107 9.48596 6.43172 9.08867 8.72899 8.97813V9.26297H8.72926V10.4302C9.14343 10.4535 9.57871 10.4656 10.0284 10.4656C10.4424 10.4656 10.8446 10.4551 11.2289 10.4358V8.97379C13.576 9.07756 15.3258 9.47903 15.3258 9.95918C15.3257 10.5181 12.954 10.9709 10.0284 10.9709Z",
  fill: "white"
});

var SvgUsdt = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUsdt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/usdt.cf04c185.svg";
export { ForwardRef as ReactComponent };